module.exports = __webpack_public_path__ + "img/1_024.03611ae3.jpg";